<template>
  <div class="referral-role-reward" :class="[columnClass, { 'has-error': error }]">
    <h6>{{ title }}</h6>
    <div class="form-group">
      <label :for="fieldId + '-type'">{{ $t('referralProgram.v2.rewardKind') }}</label>
      <select :id="fieldId + '-type'" :value="value.type" class="form-control" @change="changeType($event.target.value)">
        <option value="NONE">{{ $t('referralProgram.v2.none') }}</option>
        <option value="FLAT">{{ $t('referralProgram.cashbackTypeFlat') }}</option>
        <option value="PERCENT">{{ $t('referralProgram.cashbackTypePercent') }}</option>
        <option v-if="allowCoupons" value="COUPON">{{ $t('referralProgram.v2.coupon') }}</option>
        <option v-if="value.type === 'LEGACY'" value="LEGACY">{{ $t('referralProgram.v2.legacyCombined') }}</option>
      </select>
    </div>
    <div v-if="value.type === 'FLAT' || value.type === 'PERCENT'">
      <div class="form-group">
        <label :for="fieldId + '-value'">{{ $t(value.type === 'PERCENT' ? 'referralProgram.cashbackPercentValue' : 'referralProgram.cashbackFlatValue') }}</label>
        <input :id="fieldId + '-value'" :value="value.value" type="number" min="0" :max="value.type === 'PERCENT' ? 100 : null" step="0.0001" class="form-control" :aria-invalid="!!error" @input="update('value', $event.target.value)" />
      </div>
      <div class="form-group">
        <label :for="fieldId + '-destination'">{{ $t('referralProgram.rewardType') }}</label>
        <select :id="fieldId + '-destination'" :value="value.reward_type == null ? '' : value.reward_type" class="form-control" @change="update('reward_type', $event.target.value || null)">
          <option value="">{{ $t('referralProgram.v2.campaignDefault') }}</option>
          <option value="1" :disabled="!loyaltyEnabled">{{ $t('referralProgram.rewardTypeLoyaltyPoints') }}</option>
          <option value="2">{{ $t('referralProgram.rewardTypeWallet') }}</option>
        </select>
      </div>
    </div>
    <div v-if="value.type === 'COUPON'" class="form-group">
      <label :for="fieldId + '-coupon'">{{ $t('referralProgram.v2.selectCoupon') }}</label>
      <select :id="fieldId + '-coupon'" :value="value.coupon_id || ''" :disabled="couponsLoading" class="form-control" :aria-invalid="!!error" @change="update('coupon_id', $event.target.value)">
        <option value="">{{ $t('referralProgram.v2.selectCoupon') }}</option>
        <option v-if="missingCoupon" :value="value.coupon_id">{{ $t('referralProgram.v2.unavailableCoupon', { id: value.coupon_id }) }}</option>
        <option v-for="coupon in coupons" :key="coupon.id" :value="coupon.id">{{ coupon.name }} (#{{ coupon.id }})</option>
      </select>
      <small v-if="couponsLoading">{{ $t('referralProgram.v2.loadingCoupons') }}</small>
      <small v-else-if="!coupons.length && !missingCoupon">{{ $t('referralProgram.v2.noCoupons') }}</small>
    </div>
    <small v-if="error" class="text-danger" role="alert">{{ $t('referralProgram.v2.' + error) }}</small>
    <p class="text-muted referral-rule-summary">{{ summary }}</p>
  </div>
</template>

<script>
import { emptyRule, describeRule } from './referralRewardSettings'

export default {
  props: {
    value: { type: Object, required: true },
    allowCoupons: { type: Boolean, default: true },
    title: { type: String, required: true },
    columnClass: { type: String, default: 'col-md-4' },
    fieldId: { type: String, required: true },
    coupons: { type: Array, default: () => [] },
    couponsLoading: { type: Boolean, default: false },
    loyaltyEnabled: { type: Boolean, default: false },
    defaultRewardType: { type: Number, default: 1 },
    error: { type: String, default: '' }
  },
  computed: {
    missingCoupon () {
      return this.value.coupon_id && !this.coupons.some(coupon => Number(coupon.id) === Number(this.value.coupon_id))
    },
    summary () {
      return describeRule(this.value, this.$t.bind(this), this.defaultRewardType, this.coupons)
    }
  },
  methods: {
    update (key, value) {
      this.$emit('input', Object.assign({}, this.value, { [key]: value }))
    },
    changeType (type) {
      this.$emit('input', Object.assign(emptyRule(), { type, reward_type: this.value.reward_type }))
    }
  }
}
</script>

<style scoped>
.referral-role-reward { margin-bottom: 16px; }
.referral-role-reward h6 { font-size: 15px; margin: 12px 0; }
.referral-rule-summary { margin: 12px 0 0; overflow-wrap: break-word; }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Referral/ReferralRewardRule.vue